module.exports = __webpack_public_path__ + "img/rightTop.47d2a9fb.png";